import { Injectable } from '@angular/core';
import { Observable, map, catchError, of } from 'rxjs';
import { DataService } from './data.service';
import { environment } from 'src/environments/environment';
import { Reminder, CreateReminderPayload } from '../models/reminder.model';

@Injectable({ providedIn: 'root' })
export class RemindersService {
  private get baseUrl(): string {
    return environment.engageApiBaseUrl;
  }

  constructor(private readonly _dataService: DataService) {}

  getReminderById(id: string): Observable<Reminder> {
    const url = `${this.baseUrl}api/v1/reminders/${id}`;
    return this._dataService.get(url).pipe(
      map((res: any) => {
        const data = res?.data ?? res;
        return data ?? {};
      }),
      catchError(() => of({} as Reminder))
    );
  }

  getReminders(patientId: string): Observable<Reminder[]> {
    const url = `${this.baseUrl}api/v1/reminders/patient/${patientId}`;
    return this._dataService.get(url).pipe(
      map((res: any) => {
        const data = res?.data ?? res;
        return Array.isArray(data) ? data : (data ? [data] : []);
      }),
      catchError(() => of([]))
    );
  }

  createReminder(payload: CreateReminderPayload): Observable<Reminder> {
    const url = `${this.baseUrl}api/v1/reminders`;
    return this._dataService.post(url, payload);
  }

  updateReminder(id: string, payload: Partial<CreateReminderPayload>): Observable<Reminder> {
    const url = `${this.baseUrl}api/v1/reminders/${id}`;
    return this._dataService.patch(url, payload);
  }

  deleteReminder(id: string): Observable<void> {
    const url = `${this.baseUrl}api/v1/reminders/${id}`;
    return this._dataService.delete(url);
  }
}
